import React, { useCallback } from "react";
import * as Scrivito from "scrivito";
import { useProjectActions } from "stores/project/project/projectStore";
import { useIsAuthenticated } from "stores/user";
import cx from "classnames";

type LogoProps = {
  homepage: Scrivito.Obj;
  imgClass: string;
  isConfigLog: boolean;
  onClick: (
    event: React.MouseEvent,
    link: Scrivito.Link,
    resetProjectData: () => void,
  ) => void;
};

export const Logo = Scrivito.connect(
  ({ homepage, imgClass, isConfigLog, onClick }: LogoProps) => {
    const isAuthenticated = useIsAuthenticated();
    const actions = useProjectActions();

    const logo = isConfigLog
      ? homepage?.get("configuratorLogo")
      : homepage?.get("logo");

    const logoLink = homepage?.get("logoLink");

    const link = logoLink || homepage;

    const handleClick = useCallback(
      (event: React.MouseEvent) => {
        if (onClick && link instanceof Scrivito.Link) {
          onClick(event, link, actions.clear);
          return;
        }

        actions.clear();
      },
      [onClick, link, actions],
    );

    if (
      !homepage ||
      !(homepage?.get("logo") || homepage?.get("configuratorLogo"))
    ) {
      return null;
    }

    return (
      <>
        <Scrivito.LinkTag
          to={link as Scrivito.Link}
          onClick={handleClick}
          className={cx(imgClass, { "cursor-pointer": isAuthenticated })}
        >
          <Scrivito.ImageTag
            content={logo as Scrivito.Obj}
            alt="TROX - The art of handling air"
            style={{ minWidth: "126px" }}
          />
        </Scrivito.LinkTag>
      </>
    );
  },
);
